<div>
    <app-add-documentation *ngIf="data && !data.Success" [url]="data.URL" [isRapidScore]="isRapidScore" [headerFooter]="headerFooter"></app-add-documentation>
    <app-success-process *ngIf="data && data.Success" [url]="data.URL"  [isRapidScore]="isRapidScore" [headerFooter]="headerFooter"></app-success-process>
</div>
